import { notification } from "antd"
import Breadcrumbs from "components/Common/Breadcrumb"
import ConfigUrl, { axiosbaseurl } from "../../config"
import React, { useEffect, useMemo, useState } from "react"
import { MdAdd, MdDelete, MdEdit, MdErrorOutline, MdSend } from "react-icons/md"
import { SiTicktick } from "react-icons/si"
import { Container } from "reactstrap"
import { useNavigate } from "react-router-dom"
import Swal from "sweetalert2"
import Loader from "pages/Loader"
import { IoMdWarning } from "react-icons/io"
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"
import PermittedComponent from "PermittedComponent"
import { usePermissionData } from "AppContext"
import { RiArrowUpDownFill } from "react-icons/ri"

const Tips = () => {
  document.title = "News & Update | Return First Investments"

  const { checkAccess } = usePermissionData()

  const Navigate = useNavigate()

  const [tipsData, settipsData] = useState([])
  const [Data, setData] = useState([])

  const [Loading, setLoading] = useState(false)

  useEffect(() => {
    getData()
  }, [])

  async function getData() {
    setLoading(true)
    try {
      const response = await axiosbaseurl.get(`news/update`)
      if (response?.data?.success) {
        settipsData(response?.data?.data?.reverse())
        setData(response?.data?.data)
      }
    } catch (e) {
      console.log("Error", e.response.data.message)
    } finally {
      setLoading(false)
    }
  }

  const filterByName = e => {
    const filteredData = tipsData?.filter(
      session =>
        session.newsTitle
          .toLowerCase()
          .includes(e.target.value.toLowerCase()) ||
        session.stockName
          .toLowerCase()
          .includes(e.target.value.toLowerCase())
    )

    setData(filteredData)
  }

  const handleDelete = ID => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this News & Update",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          const response = await axiosbaseurl.delete(`/news/update/${ID}`) // Use correct API endpoint

          if (response?.data?.success) {
            notification.open({
              message: (
                <div className="d-flex align-items-center">
                  <div className="pr-20">
                    <SiTicktick className="text-success fs-4 me-2" />
                  </div>
                  <div className="succes-message">
                    Tip Deleted Successfully.
                  </div>
                </div>
              ),
              placement: "topRight",
            })

            // Refresh user list after delete
            getData()
          }
        } catch (error) {
          notification.open({
            message: (
              <div className="d-flex">
                <div className="pr-10">
                  <IoMdWarning className="text-danger" size={22} />
                </div>
                <div>Opps! Something went wrong.</div>
              </div>
            ),
            description: error?.response?.data?.message,
          })
        }
      }
    })
  }

  const [page, setPage] = useState(1)

  useEffect(() => window.scrollTo(0, 0), [])

  const [items_perpage, setItemsPerPage] = useState(10)

  const total_pages = Math.ceil(Data?.length / items_perpage)

  const changePage = pagecount => {
    if (pagecount > 0 && pagecount <= total_pages) {
      setPage(pagecount)
      window.scrollTo(0, 0)
    }
  }

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  })

  const requestSort = key => {
    let direction = "ascending"
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending"
    }
    setSortConfig({ key, direction })
  }

  const getSortArrow = key => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "ascending" ? "▲" : "▼"
    }
    return <RiArrowUpDownFill size={18} />
  }

  const sortedData = useMemo(() => {
    if (!sortConfig.key) return Data

    const sorted = [...Data].sort((a, b) => {
      let aVal = a[sortConfig.key] ?? ""
      let bVal = b[sortConfig.key] ?? ""

      if (sortConfig.key === "tradeType") {
        const typeMap = { 1: "Equity", 2: "Intraday", 3: "Options" }
        aVal = typeMap[a.tradeType] ?? ""
        bVal = typeMap[b.tradeType] ?? ""
      }

      if (typeof aVal === "string") aVal = aVal.toLowerCase()
      if (typeof bVal === "string") bVal = bVal.toLowerCase()

      if (aVal < bVal) return sortConfig.direction === "ascending" ? -1 : 1
      if (aVal > bVal) return sortConfig.direction === "ascending" ? 1 : -1
      return 0
    })

    return sorted
  }, [Data, sortConfig])

  const final_data = sortedData.slice(
    (page - 1) * items_perpage,
    page * items_perpage
  )

  return (
    <React.Fragment>
      {Loading && <Loader />}
      <PermittedComponent isAccess={checkAccess(2, 1)}>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs title={""} breadcrumbItem={"News & Update"} />

            <div className="card p-2 py-3">
              <div className="d-flex flex-column flex-xl-row justify-content-between">
                <div className="search-box position-relative">
                  <input
                    className="form-control ps-6"
                    onChange={filterByName}
                    placeholder="Search News"
                  />
                  <i className="bx bx-search-alt search-icon"></i>
                </div>

                <div>
                  {/* <button className="btn Add-Button rounded-5 me-2" onClick={handleSendTips}>
                                        <MdSend /> Send Tip
                                    </button> */}
                  {checkAccess(2, 2) && (
                    <button
                      className="btn Add-Button rounded-5 mt-3 mt-xl-0"
                      onClick={() => Navigate(`${ConfigUrl.appurl}add-tip`)}
                    >
                      <MdAdd /> Add News
                    </button>
                  )}
                </div>
              </div>

              <div className="table-responsive mt-4">
                <table className="mb-0 table Custom-Table">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("newsTitle")}
                      >
                        News Title {getSortArrow("newsTitle")}
                      </th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("stockName")}
                      >
                        Stock Name {getSortArrow("stockName")}
                      </th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {final_data.map((tip, index) => (
                      <tr key={tip.id}>
                        <td>{(page - 1) * items_perpage + index + 1}</td>
                        <td className="">{tip.newsTitle}</td>
                        <td>{tip.stockName || "-"}</td>
                        <td>
                          <div className=" d-flex justify-content-center align-items-start">
                            {checkAccess(2, 3) && (
                              <button
                                className="btn Edit-Button me-2 rounded-5"
                                onClick={() =>
                                  Navigate(
                                    `${ConfigUrl.appurl}edit-tip/${tip?.id}`
                                  )
                                }
                              >
                                <MdEdit /> Edit
                              </button>
                            )}
                            {checkAccess(2, 4) && (
                              <button
                                className="btn delete-Button rounded-5"
                                onClick={() => handleDelete(tip?.id)}
                              >
                                <MdDelete /> Delete
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="d-flex align-items-center justify-content-between my-4 px-2">
                <p className="mb-0 fs-6">
                  Showing {final_data?.length} out of {Data?.length} News &
                  Update.
                </p>
                <div className="d-flex justify-content-md-start justify-content-center flex-wrap">
                  <div
                    className={`bd-number-pagination cursor-pointer rounded-2 me-2 fs-5`}
                    onClick={() => changePage(page - 1)}
                    style={{ cursor: "pointer" }}
                  >
                    <FaChevronLeft />
                  </div>
                  {(() => {
                    const maxVisiblePages = 5
                    const startPage = Math.max(
                      1,
                      page - Math.floor(maxVisiblePages / 2)
                    )
                    const endPage = Math.min(
                      total_pages,
                      startPage + maxVisiblePages - 1
                    )
                    const visiblePages = []

                    for (let i = startPage; i <= endPage; i++) {
                      visiblePages.push(i)
                    }

                    return visiblePages.map(pagecount => (
                      <div
                        key={pagecount}
                        className={`bd-number-pagination cursor-pointer rounded-2 me-1 fs-5 ${
                          page === pagecount ? "activepage" : ""
                        }`}
                        style={{ cursor: "pointer" }}
                        onClick={() => changePage(pagecount)}
                      >
                        {pagecount < 10 ? "0" + pagecount : pagecount}
                      </div>
                    ))
                  })()}
                  <div
                    className={`bd-number-pagination cursor-pointer rounded-2 ms-2 fs-5`}
                    onClick={() => changePage(page + 1)}
                    style={{ cursor: "pointer" }}
                  >
                    <FaChevronRight />
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </PermittedComponent>
    </React.Fragment>
  )
}

export default Tips
